import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./auth/context";
import { ConfirmProvider } from "./components/ui/ConfirmDialog";
import { ToastProvider } from "./components/ui/Toast";

// NOTE: We intentionally don't wrap in <React.StrictMode>. In development
// StrictMode double-invokes effects (mount -> unmount -> mount), which fires
// every data-fetching useEffect twice on first load. That's dev-only, but it
// makes the network tab noisy and double-hits the API, so we opt out to keep
// dev behavior matching production.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <ConfirmProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ConfirmProvider>
    </AuthProvider>
  </BrowserRouter>
);
